import Gleap from 'gleap';

export function openHelp(articleId: string, showBackButton = false): void {
  if (typeof Gleap !== 'undefined' && Gleap.openHelpCenterArticle) {
    Gleap.openHelpCenterArticle(articleId, showBackButton);
  } else {
    console.warn('[Gleap] Gleap is not available.');
  }
}

/**
 * Supprime la session Gleap laissée dans le localStorage par un autre contact que celui à identifier
 * (autre compte de ce navigateur, ou autre boutique pour un sous-utilisateur, cf. getGleapUserId()).
 *
 * Au chargement de page, identify() part avant Gleap.initialize() : clearIdentity() n'a alors aucun effet
 * (session en mémoire encore vide) et initialize() recharge la session en cache. Les réponses de /sessions
 * (compte précédent) et /sessions/identify (compte courant) se font la course et la dernière gagne : la page
 * peut rester rattachée au contact du compte précédent, dont les customData (hasNoOffer…) déclenchent ses
 * bannières (SC-3871). Sans cache, le SDK attend la réponse de /sessions avant d'envoyer identify.
 */
export function dropForeignGleapSession(userId: string): void {
  const cacheKey = `gleap-widget-session-${process.env.VUE_APP_GLEAP_API_KEY || ''}`;

  try {
    const cachedSession = localStorage.getItem(cacheKey);
    if (cachedSession && String(JSON.parse(cachedSession)?.userId ?? '') !== userId) {
      localStorage.removeItem(cacheKey);
    }
  } catch (e) {
    // Cache illisible ou localStorage indisponible : le SDK repartira d'une session neuve
    console.warn('[Gleap] Unable to check the cached session.', e);
  }
}
